import React, { useContext, useEffect } from "react";
import {
    GridRow,
    GridColumn,
    ListTable,
    Grid,
    SearchBox,
    Stack,
    ClearFiltersButton,
    ContentSection,
    createListTableColumns,
    renderDateTime,
    ButtonRenderProps,
    ButtonProps
} from "sprint-common-web";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../../AdminRoutes";
import { OriginatorListingContext } from "../context/OriginatorListingContext";
import { OriginatorListingItem } from "../context/OriginatorListingItem";
import { CreateOriginatorButton } from "../create/CreateOriginatorButton";
import { useOriginatorListingFilters } from "./useOriginatorListingFilters";

export const OriginatorListing: React.FC = () => {
    const { filters, setSort, setPage, setPageSize, setName, clearFilters } = useOriginatorListingFilters();
    const { items, isLoading, totalItems, load } = useContext(OriginatorListingContext);

    useEffect(() => {
        load(filters);
    }, [filters, isLoading, items.length]);

    const columns = createListTableColumns<OriginatorListingItem>([
        {
            type: "basic",
            key: "name",
            name: "Name",
            minWidth: 200,
            maxWidth: 380,
            isSortable: true
        },
        {
            type: "basic",
            key: "updatedDate",
            name: "Updated",
            minWidth: 100,
            maxWidth: 280,
            isSortable: true,
            onRender: renderDateTime
        }
    ]);

    const createOriginatorButtonProps: ButtonRenderProps<ButtonProps> = {
        render: CreateOriginatorButton
    };

    return (
        <>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <ContentSection header={"Originators"} buttons={[createOriginatorButtonProps]}>
                <Grid>
                    <GridRow>
                        <GridColumn sm={3}>
                            <SearchBox placeholder="Name" onChange={setName} value={filters.name} />
                        </GridColumn>
                        <GridColumn sm={9}>
                            <Stack horizontalAlign="end">
                                <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                            </Stack>
                        </GridColumn>
                    </GridRow>
                    <GridRow>
                        <GridColumn sm={12}>
                            <ListTable
                                columns={columns}
                                items={items}
                                pagination={{
                                    page: filters.page,
                                    pageSize: filters.pageSize,
                                    totalItems,
                                    onPageChange: setPage,
                                    onPageSizeChange: setPageSize
                                }}
                                sort={{ by: filters.sortBy, order: filters.sortOrder }}
                                onSortChange={setSort}
                                isLoading={isLoading}
                            />
                        </GridColumn>
                    </GridRow>
                </Grid>
            </ContentSection>
        </>
    );
};
